import { useEffect } from 'react';
import { useStoryStore } from '../stores/useStoryStore';
import { useUIStore } from '../stores/useUIStore';
import { isTvClient } from '../utils/tvClient';

declare global {
  interface Window {
    // Called by the Fire TV shell on the remote's Back key; true = handled, false = shell exits.
    ys520TvBack?: () => boolean;
  }
}

/** Closes the top-most overlay (media modal, then story card); reports whether one was open. */
export function closeTopOverlay(): boolean {
  const ui = useUIStore.getState();
  if (ui.isMediaModalOpen) {
    ui.closeMediaModal();
    return true;
  }

  const story = useStoryStore.getState();
  if (story.isVisible) {
    story.closeStory();
    return true;
  }

  return false;
}

/** Exposes {@link closeTopOverlay} to the Fire TV shell as `window.ys520TvBack`, on the TV only. */
export function useTvBackBridge(): void {
  useEffect(() => {
    if (!isTvClient()) {
      return;
    }

    window.ys520TvBack = closeTopOverlay;

    return () => {
      delete window.ys520TvBack;
    };
  }, []);
}
